import React from "react";
import CategoryTree from "../pages/CategoryTree.js";
import CustomerForm from "../pages/CustomerForm.js";
import "../styles/Content.css";

class Content extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: []
        };

    }
    parentData = (values) => {
        this.setState({ data: values })
    }
    render() {
        return (
            <div className="container-fluid">
                <section className="content-header">
                    <h1>
                        Płatności za czynności urzędowe
                    </h1>
                </section>
                <section className="content2">
                    <CategoryTree parentData={this.parentData} />
                    <CustomerForm parentData={this.state.data} ancestorProps={this.props} />
                </section>
            </div>
        )
    }
}

export default Content